import { WEEK_DAY_GROUP } from "@/components";
import dayjs from "dayjs";

export const handleWeekDay = (date: string) => {
    const weekDayName = WEEK_DAY_GROUP.find((week) => week.weekNum === dayjs(date).day())?.weekDay;
    return weekDayName;
};
